<template>
  <main class="account-main">
    <div class="form">
      <h1 class="text-phaneroo-500 text-5xl font-bold">Login</h1>
      <p class="text-orange-400 text-xl">Every day is a day of victory. A continual feast in the presence of God</p>
      <form @submit.prevent class="form my-8">
        <!-- TODO: add validation with Vuelidate -->
        <b-field label="Email">
          <b-input
            v-model="email"
            type="email"
            placeholder="email@example.com"
            inputmode="email"
          />
        </b-field>
        <b-field label="Password">
          <div class="flex" slot="label">
            <label for="password">Password</label>
            <router-link
              class="ml-auto text-phaneroo-400 underline"
              :to="{ path: '/account/forgotpassword' }"
            >
              Forgot Password?
            </router-link>
          </div>
          <b-input
            name="password"
            v-model="password"
            type="password"
            inputmode="password"
            password-reveal
            @keydown.enter="login"
          />
        </b-field>

        <b-button
          icon-left="sign-in"
          type="is-primary"
          class="mt-8 is-medium"
          expanded
          @click="login"
        >
          Login
        </b-button>
        <router-link
          class="text-center block mt-6 text-phaneroo-400 underline"
          :to="{ path: '/admin/signup'}"
        >
          Don't have an account?
        </router-link>
      </form>
    </div>
  </main>
</template>

<script>
export default {
  name: 'LoginPage',
  data () {
    return {
      email: '',
      password: ''
    }
  },
  computed: {
    user () {
      return this.$store.getters['auth/user']
    },
    userId () {
      return this.$store.getters['auth/userId']
    },
    authToken () {
      return this.$store.getters['auth/authToken']
    },
    isAuthenticated () {
      return (this.user && this.authToken)
    }
  },
  methods: {
    async login () {
      const credentials = {
        email: this.email,
        password: this.password
      }
      try {
        await this.$store.dispatch('auth/login', credentials)
        await this.$store.dispatch('users/getUserById', this.userId)
        if (this.isAuthenticated) {
          this.$notify('Redirecting to dashboard...', {
            type: 'success',
            title: 'Login successful!',
            duration: 3000
          })
          if (this.user.isAdmin || this.user.isPastor) {
            setTimeout(() => {
              this.$router.push('/dashboard')
            }, 1000)
          } else {
            this.$notify('Only admins are allowed to login. Please contact the site moderator for more information.', {
              type: 'warning',
              title: 'Unauthorized',
              duration: 3000
            })
          }
        }
      } catch (error) {
        console.error('Something went wrong.', error)
        this.$sentry.captureException(error)
        this.$notify('Please make sure your email and password are correct', {
          type: 'error',
          title: 'Authentication failed',
          duration: 5000
        })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.account-main {
  @apply flex flex-col justify-center items-center;
  min-height: calc(100vh - 52px);

  .form {
    width: 400px;
  }
}

@media(max-width: 768px) {
  .account-main {
    .form {
      width: 300px;
    }
  }
}
</style>
